import { IMDSSelectProps } from "./select.types";
import { StyledButtonContent, StyledSelect } from "./select.style";
import { MDSButton, MDSButtonVariant } from "@/mds/components/buttons";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { useState } from "react";
import { MDSSelectMenuWithContent } from "@/mds/components/menu/select-menu";
import { MDSMenuDropdownPopover } from "@/mds/components/menu/menu-dropdown";
import { SelectValue } from "react-aria-components";

/**
 * MDS Select component based on react-aria Select
 * Provides an accessible select input with MDS styling
 */
export function MDSSelect(props: IMDSSelectProps) {
  const {
    label,
    defaultOpen,
    onOpenChange,
    items,
    popoverProps,
    buttonProps,
    renderSelectValue,
    buttonVariant,
    ...rest
  } = props;

  const [_isOpen, _setIsOpen] = useState(defaultOpen);

  const handleOpenChange = (open: boolean) => {
    _setIsOpen(open);
    onOpenChange?.(open);
  };

  const mergedPopoverProps = popoverProps;

  return (
    <StyledSelect
      aria-label={label}
      data-mds-name="select"
      label={label}
      items={items}
      isOpen={_isOpen}
      onOpenChange={handleOpenChange}
      {...rest}
    >
      <MDSButton variant={buttonVariant ?? MDSButtonVariant.Transparent} {...buttonProps}>
        <StyledButtonContent>
          <SelectValue>
            {props => (renderSelectValue ? renderSelectValue(props) : props.selectedText)}
          </SelectValue>
          <div aria-hidden="true">
            <MDSIcon kind={MDSIconKind.CaretDown} data-test-id="select-toggle-icon" />
          </div>
        </StyledButtonContent>
      </MDSButton>
      <MDSMenuDropdownPopover {...mergedPopoverProps}>
        <MDSSelectMenuWithContent contentList={items} />
      </MDSMenuDropdownPopover>
    </StyledSelect>
  );
}
